import {PropsWithChildren} from 'react';

import * as styles from './right-content.scss';

export function RightContent(props: PropsWithChildren<unknown>): JSX.Element {
    const {children} = props;

    return <div className={styles.RightContent}>{children}</div>;
}
